// tools
import { getDeviceId } from '@tools/amplitude'

const CLARITY_PROJECT_ID = 'pyhh7whwpd'
const AMPLITUDE_PROJECT_ID = 472284
const MAX_DEVICE_ID_RETRIES = 10
const DEVICE_ID_RETRY_DELAY_MS = 800

let initialized = false

const getAmplitudeUrl = (deviceId: string): string =>
  `https://app.amplitude.com/analytics/skelar/project/${AMPLITUDE_PROJECT_ID}/search/${deviceId}`

export const initClarity = async (retry: number = 0): Promise<void> => {
  if (initialized) return

  const deviceId = getDeviceId()

  if (!deviceId) {
    if (retry >= MAX_DEVICE_ID_RETRIES) {
      console.warn('initClarity: amplitude deviceId is not available — giving up')
      return
    }
    setTimeout(() => initClarity(retry + 1), DEVICE_ID_RETRY_DELAY_MS)
    return
  }

  const { environment } = useRuntimeConfig().public
  const { default: Clarity } = await import('@microsoft/clarity')

  Clarity.init(CLARITY_PROJECT_ID)
  Clarity.identify(deviceId)
  Clarity.setTag('device_id', deviceId)
  Clarity.setTag('amplitude_url', getAmplitudeUrl(deviceId))
  Clarity.setTag('environment', environment || '')
  Clarity.setTag('source', 'seo-site')

  initialized = true
}
